export { default } from "./withStrengthTooltip";
